import { createTheme } from '@mantine/core';

export const theme = createTheme({
  fontFamily: 'Marcellus, serif',
  // ... other theme override properties
});